'use client'

import { useState, useEffect } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '@/lib/firebase'

type BookingMode = 'direct' | 'whatsapp' | 'hidden'

export function useBookingMode(productId: string, fallback: BookingMode): BookingMode {
  const [mode, setMode] = useState<BookingMode>(fallback)

  useEffect(() => {
    const docRef = doc(db, 'settings', 'bookingModes')
    getDoc(docRef)
      .then(snap => {
        if (snap.exists()) {
          const data = snap.data()
          if (data[productId] === 'direct' || data[productId] === 'whatsapp' || data[productId] === 'hidden') {
            setMode(data[productId] as BookingMode)
          }
        }
      })
      .catch(() => {
        // keep fallback silently
      })
    return () => {}
  }, [productId])

  return mode
}
